export default __webpack_public_path__ + "static/media/gallery-wip-bunny-ears_06.57f548d9.jpg";